module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img43.c7f2ec4f.jpg";